module.exports = __webpack_public_path__ + "static/media/curve_image1.9b771a33.jpg";